<template>
   <div class="modal" v-show="show">
    <div class="modal-wrapper">
      <div class="modal-container">
            <div class="modal-header">{{ modalTitle }}</div>
            <div class="modal-body">
               <template v-if="showSignature">
                   <p class="signature-title">Firma de recibido{{ signatureOptional ? ' (opcional)' : '' }}: <vs-button @click="clear" color="primary" type="flat">Limpiar</vs-button></p>
                   <vueSignature :key="packageId" ref="signature" :sigOption="option" :w="'100%'" :h="'150px'"></vueSignature>
                   <br>
                   <p class="signature-title">¿El cliente pudo calificar? <vs-switch v-model="canRate" color="success" @change="toggleCanRate"/></p>
               </template>
               <template v-if="canRate">
                   <p>¿Como calificas nuestro servicio?</p><br/>
                   <div class="option-stars">
                        <template v-for="star in [1,2,3,4,5]">
                            <feather :key="star" :class="{'active': star <= score}" type="star" @click="userSurveyClicked(star)"></feather>
                        </template>
                   </div>
               </template>
               <template v-else>
                   <p>Motivo de no calificación:</p><br/>
                   <vs-select autocomplete placeholder="Motivo de no calificación" v-model="reason" class="survey-reason">
                       <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in reasons" />
                   </vs-select>
               </template>
               <p class="error-survey">{{ message }}</p>
            </div>
            <div class="modal-footer">
                <vs-button color="danger" type="border" icon="block" @click="closeModal()">Cancelar</vs-button>
                <vs-button  :disabled="confirmStatus" 
                    id="btnConfirm" color="success" @click="updatePackageStatus()" type="border" icon="check" class="vs-con-loading__container">Enviar</vs-button>
            </div>  
      </div>
    </div>
  </div>
</template>
<script>
import {helper} from '@/helpers/utils'
import vueSignature from "vue-signature";
import PackageDataService from "@/services/PackageDataService";
import { SurveyReasons } from "@/helpers/SurveyReasons";
export default {
  name: 'ModalPackageStatus',
  mixins: [helper],
  components: { vueSignature },
  props: {
    show: { type: Boolean, required: true },
    packID: { type: String, required: true },
    customer:{ required: true },
    selected: { type: Object, default: () => {} },
    packIDs: { type: Array, default: () => [] },
    modeUdpdate: { type: Boolean, default: false },
    showSignature: { type: Boolean, default: true },
  },
  data() {
    return {
      active: false,
      newStatus: this.selected,
      packageId: this.packID,
      confirmStatus: false,
      notify: false,
      status: [],
      score: 0,
      reason: "",
      canRate: true,
      reasons: SurveyReasons,
      customerId: this.customer,
      option:{
            penColor:"rgb(0, 0, 0)",
            backgroundColor:"rgb(240, 240, 240)"
        },
        message: ""
    }
  },
  computed: {
    packageIds () {
        return this.packIDs && this.packIDs.length > 0 ? this.packIDs : [this.packageId]
    },
    modalTitle () {
        if(!this.showSignature) return '¡Califica nuestro servicio!'
        return this.packageIds.length > 1
            ? `¡Entrega de ${this.packageIds.length} paquetes!`
            : '¡Entrega de paquete!'
    },
    // La firma solo es opcional cuando el cliente ni siquiera estaba disponible
    // para recibir: en los demás motivos (tercero, se negó a calificar) hay
    // alguien presente que puede firmar.
    signatureOptional () {
        return !this.canRate && this.reason === 'CLIENT_UNAVAILABLE'
    }
  },
  watch: {
    packID () {
      this.packageId = this.packID
    },
    customer (val) {
        this.customerId = val
    },
    // El mensaje de error queda desactualizado apenas el usuario cambia
    // cualquier respuesta (ej. firma ya no requerida al elegir "Cliente no
    // estaba disponible"), así que se limpia en cuanto algo cambia.
    score () { this.message = "" },
    reason () { this.message = "" },
    canRate () { this.message = "" }

  },
  methods: {
    clear() {
        this.score = 0;
        this.reason = "";
        this.canRate = true;
        if(this.showSignature) this.$refs.signature.clear()
    },
    userSurveyClicked (score) {
        this.score = score
    },
    toggleCanRate (value) {
        if(value) this.reason = ""
        else this.score = 0
    },
    closeModal () {
        this.clear();
        this.$emit('modal-event', { status: "closed", active: false})
    },
    confirmButton() {
      this.$emit('confirm-modal', this.selected, true)
    },
    updatePackageStatus() {

        if(this.canRate && this.score == 0) {
            this.message = "Favor calificar el servicio para continuar.";
            return false;
        }
        if(!this.canRate && this.reason == "") {
            this.message = "Favor seleccionar un motivo de no calificación.";
            return false;
        }
        if(this.showSignature && !this.signatureOptional && this.$refs.signature.isEmpty()) {
            this.message = "Favor completar la firma de recibido para continuar.";
            return false;
        }
        this.message = "";
        const that = this
        that.loadingProgress ('#btnConfirm')
        that.confirmStatus = true

        const _signature = this.showSignature && !this.$refs.signature.isEmpty() ? this.$refs.signature.save() : null
        // Misma firma/calificacion (o motivo) para todos los paquetes seleccionados:
        // varias entregas al mismo cliente se procesan como una sola.
        Promise.all(this.packageIds.map(id => PackageDataService.saveUserFeedback({
            cu01Id: this.customerId,
            pkg01Id: id,
            answer: this.canRate ? this.score : null,
            reason: this.canRate ? null : this.reason,
            signature: _signature
        })))
        .then(response => {
                console.log(response)
                that.confirmStatus = false
                this.clear();
                that.$vs.loading.close('#btnConfirm .con-vs-loading')
                that.$emit('modal-event', { message: response, status:"confirmed", response: this.newStatus, error: false, active: false})
        })
        .catch(e => {
            console.log(e)
            that.confirmStatus = false
            that.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
            that.$emit('modal-event', { message: e, status:"confirmed", error: true, active: false})
        });
    },
  }
}
</script>
